import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: 'about'
  }, {
    name: 'Programs',
    href: 'programs'
  }, {
    name: 'Gallery',
    href: 'gallery'
  }, {
    name: 'Contact',
    href: 'contact'
  }];
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setIsOpen(false);
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-forest/95 backdrop-blur-md shadow-lg py-3' : 'bg-forest/80 backdrop-blur-sm py-5'}`} data-id="element-74">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        <div className="flex justify-between items-center" data-id="element-76">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} data-id="element-77">
            <img src="https://cdn.magicpatterns.com/uploads/nvcxggdRAb1MpybQfVMZFq/camp-badge.png" alt="Camp ALKEBULAN Badge" className="w-10 h-10 object-contain" data-id="element-78" />
            <span className="font-heading text-gold text-xl font-bold tracking-wide" data-id="element-79">
              Camp ALKEBULAN
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-80">
            {navLinks.map(link => <button key={link.name} onClick={() => scrollTo(link.href)} className="text-cream hover:text-gold transition-colors font-medium text-sm uppercase tracking-wider" data-id="element-81">
                {link.name}
              </button>)}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-82">
            <button onClick={() => setIsOpen(!isOpen)} className="text-cream hover:text-gold transition-colors p-2" aria-label="Toggle menu" data-id="element-83">
              {isOpen ? <XIcon size={24} data-id="element-84" /> : <MenuIcon size={24} data-id="element-85" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-86">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-forest border-t border-white/10 overflow-hidden" data-id="element-87">
            <div className="px-4 pt-2 pb-6 space-y-1 flex flex-col" data-id="element-88">
              {navLinks.map(link => <button key={link.name} onClick={() => scrollTo(link.href)} className="text-cream hover:text-gold hover:bg-white/5 block px-3 py-4 rounded-md text-base font-medium text-left uppercase tracking-wider transition-colors" data-id="element-89">
                  {link.name}
                </button>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}